import styled from 'styled-components';

export const TierTag = styled.div`
  display: inline-block;
  border-radius: 5px;
  padding: 2px 5px;
  color: ${({ theme }) => theme.colors.background};
`;

export const Tier1Tag = styled(TierTag)`
  background-color: ${({ theme }) => theme.colors.lightDanger};
`;

export const Tier2Tag = styled(TierTag)`
  background-color: ${({ theme }) => theme.colors.lightWarning};
  color: ${({ theme }) => theme.colors.lightWarningText};
`;

export const Tier3Tag = styled(TierTag)`
  background-color: ${({ theme }) => theme.colors.success};
`;
